import initReactApp from 'dpl/util/initReactApp';
import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';

initReactApp({
  NewsletterFormContainer
});
